import React, { useEffect, useMemo, useState } from 'react'
import { Card, EmptyState, PageTitle, SearchField, StatusBadge, formatDate } from '../components/Ui'
import { adminRequest } from '../api/client'

const FILTERS = [
  ['ALL','전체'],
  ['PENDING','심사 대기']
]

export default function DirectorApplications({ navigate }) {
  const [items, setItems] = useState([])
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    let disposed = false
    adminRequest('/api/v1/admin/director-applications')
      .then((response) => { if (!disposed) setItems(Array.isArray(response?.data) ? response.data : []) })
      .catch((reason) => { if (!disposed) setError(reason?.message || '디렉터 신청 목록을 불러오지 못했습니다.') })
      .finally(() => { if (!disposed) setLoading(false) })
    return () => { disposed = true }
  }, [])

  const filtered = useMemo(() => items.filter((item) => {
    const haystack = [item.memberName, item.nickname, item.brandName, item.representativeName, item.email, item.legalName, item.registrationNo].filter(Boolean).join(' ').toLowerCase()
    return (!search || haystack.includes(search.toLowerCase())) && (status === 'ALL' || item.status === status)
  }), [items, search, status])

  const count = (key) => key === 'ALL' ? items.length : items.filter((item) => item.status === key).length

  return <>
    <PageTitle eyebrow="DIRECTOR APPLICATIONS" title="디렉터 신청 관리" description="기존 회원 계정에서 디렉터 역할을 신청한 뒤 아직 승인되지 않은 건만 심사합니다. 승인 후에는 전체 회원에서 디렉터 역할로 관리됩니다." />
    <div className="application-status-strip application-status-strip--compact">
      {FILTERS.map(([key, label]) => <button type="button" key={key} className={status === key ? 'is-active' : ''} onClick={() => setStatus(key)}><span>{label}</span><strong>{count(key)}</strong></button>)}
    </div>
    {error ? <div className="admin-notice"><strong>오류</strong><span>{error}</span></div> : null}
    <Card className="table-card">
      <div className="table-toolbar">
        <SearchField value={search} onChange={setSearch} placeholder="회원명, 업체명, 대표자, 이메일, 사업자등록번호 검색" />
        <div className="filter-buttons">{FILTERS.map(([key, label]) => <button type="button" key={key} className={status === key ? 'active' : ''} onClick={() => setStatus(key)}>{label}</button>)}</div>
      </div>
      <div className="table-result-bar"><span>심사 대상 <strong>{filtered.length}</strong>건</span><small>승인된 디렉터는 이 목록에서 제외됩니다.</small></div>
      {loading ? <div className="admin-empty-inline">디렉터 신청을 불러오는 중입니다.</div> : filtered.length ? <div className="table-scroll"><table className="data-table"><thead><tr><th>회원/신청자</th><th>업체명</th><th>사업자등록번호</th><th>사업자 자료</th><th>신청 상태</th><th>요청일</th></tr></thead><tbody>{filtered.map((item) => <tr className="clickable-row" key={item.id} onClick={() => navigate(`/directors/${item.id}`)}>
        <td><strong>{item.memberName || item.representativeName || '-'}</strong><small>{item.email || '-'}</small></td>
        <td>{item.brandName || item.legalName || '-'}</td>
        <td>{item.registrationNo || '-'}</td>
        <td><StatusBadge status={item.businessStatus || 'PENDING'} /></td>
        <td><StatusBadge status="PENDING">심사 대기</StatusBadge></td>
        <td>{item.reviewRequestedAt ? formatDate(item.reviewRequestedAt, true) : item.createdAt ? formatDate(item.createdAt, true) : '-'}</td>
      </tr>)}</tbody></table></div> : <EmptyState title="심사 대기 중인 디렉터 신청이 없습니다." description="회원이 디렉터 역할을 신청하면 이곳에 표시됩니다." />}
    </Card>
  </>
}
